import { render } from "./stock_return_report_table.vue?vue&type=template&id=196f0a62&scoped=true"
import script from "./stock_return_report_table.vue?vue&type=script&lang=js"
export * from "./stock_return_report_table.vue?vue&type=script&lang=js"

import "./stock_return_report_table.vue?vue&type=style&index=0&id=196f0a62&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-196f0a62"]])

export default __exports__